import { EditorLanguageContext } from '@app/components/cms/context/EditorLanguageContext';
import { EditorUIContext } from '@app/components/cms/context/EditorUIContext';
import { useCmsPreviewProducts } from '@app/services/hooks/pages/useCmsPreviewProducts';
import { isDefined } from '@app/utils/is';
import { Cms, CmsBlocks } from '@typings';
import React from 'react';
import { useInView } from 'react-intersection-observer';

import { usePageProductsContext } from '../../context/PageProductsContext';

import { ContentBlock } from './ContentBlock';

export const PreviewContentBlock = (props: CmsBlocks.BlockProps<Cms.ContentBlock>) => {
  const { parameters } = props;
  const { settings } = parameters;
  const { hotspots } = settings;
  const [ref, isInView] = useInView({
    rootMargin: '200px 0px',
    triggerOnce: true,
  });
  const { editorLanguage } = React.useContext(EditorLanguageContext);
  const { previewSegmentation } = React.useContext(EditorUIContext);
  const { handleProductsUpdate } = usePageProductsContext();
  const productIds = (hotspots?.points ?? []).map(point => point.general.productId).filter(isDefined);
  const { data: productsData, isLoading } = useCmsPreviewProducts({
    isEnabled: isInView,
    payload: {
      editorLanguage,
      limit: 0,
      marketIds: [previewSegmentation.marketId].filter(isDefined),
      products: productIds,
      skipFirst: 0,
    },
  });
  React.useEffect(() => {
    if (isDefined(productsData)) {
      handleProductsUpdate?.(productsData);
    }
  }, [productsData, handleProductsUpdate]);

  return <ContentBlock productsData={productsData} isLoading={isLoading} {...props} ref={ref} />;
};
